import { NumberOrNull } from './customTypes'

interface Constant {
  id: number,
  text: string
}

export interface Dress {
  id?: number,
  designer: number,
  name: string,
  description: string,
  minPrice: NumberOrNull,
  maxPrice: NumberOrNull,
  currency: string,
  upc: string,
  imageurls: string[],
  documenturls: string[],
  styles: Constant[],
  colors: Constant[],
}

export const generateEmptyDress = (): Dress => ({
  designer: 0,
  name: '',
  description: '',
  minPrice: null,
  maxPrice: null,
  currency: '',
  upc: '',
  imageurls: [],
  documenturls: [],
  styles: [],
  colors: []
})
